import {
  useEffect, useState,
} from 'react';
// import { useHistory } from 'react-router-dom';
// import devicesApi from '@api/devicesApi';

function useDashboardGeneral() {

  const [rol, setRol] = useState('');

  const [loading, setLoading] = useState(true);
  const [loadingBusiness, setLoadingBusiness] = useState(true);

  useEffect(() => {

    setLoading(false);
    setLoadingBusiness(false);

    setRol('Visitante');

  }, []);

  return {
    loading,
    loadingBusiness,
    rol,
  };

}

export default useDashboardGeneral;
